import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { BASE_API_URL } from "../services/baseURL";
import { roles, useAuth } from "../services/auth";
import useNotificationStore from "../Store/Notifications/NotificationStore";

const NOTIFICATION_SOUND_URL =
  require("../assets/sounds/notification.mp3").default;

const socket = io(BASE_API_URL);

const useNotificationListener = () => {
  const { currentUUID, currentRoleId } = useAuth();
  const addNotification = useNotificationStore(
    (state) => state.addNotification
  );
  const loadUnreadNotifications = useNotificationStore(
    (state) => state.loadUnreadNotifications
  );
  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    const onConnect = () => {
      setIsConnected(true);
    };

    const onDisconnect = () => {
      setIsConnected(false);
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, [addNotification]);

  useEffect(() => {
    if (currentUUID && currentRoleId) {
      loadUnreadNotifications();
    }
  }, [loadUnreadNotifications, currentUUID, currentRoleId]);

  useEffect(() => {
    const playNotificationSound = () => {
      try {
        const audio = new Audio(NOTIFICATION_SOUND_URL);
        audio
          .play()
          .catch((e) =>
            console.error("Error reproduciendo el sonido de notificación:", e)
          );
      } catch (error) {
        console.error("Error al crear el objeto de audio:", error);
      }
    };

    if (!currentRoleId || !isConnected) return;

    const handleSalespersonMessage = (data: any) => {
      if (
        currentRoleId === roles.salesperson &&
        data.salespersonUuid === currentUUID
      ) {
        addNotification({
          message: data.message,
          sender: {
            id: data.sender.id,
            name: `${data.sender.first_name} ${data.sender.last_name}`,
            avatar: data.sender.avatar,
          },
          salesConsultancyHashid: data.salesConsultancyHashid,
          roomUuid: data.roomUuid,
          timestamp: new Date(data.timestamp),
          type: "message",
        });
        playNotificationSound();
      }
    };

    const handleClientMessage = (data: any) => {
      if (currentRoleId === roles.client && data.clientUuid === currentUUID) {
        addNotification({
          message: data.message,
          sender: {
            id: data.sender.id,
            name: `${data.sender.first_name} ${data.sender.last_name}`,
            avatar: data.sender.avatar,
          },
          salesConsultancyHashid: data.salesConsultancyHashid,
          roomUuid: data.roomUuid,
          timestamp: new Date(data.timestamp),
          type: "message",
        });
        playNotificationSound();
      }
    };

    socket.on("new-salesperson-message", handleSalespersonMessage);
    socket.on("new-client-message", handleClientMessage);

    return () => {
      socket.off("new-salesperson-message", handleSalespersonMessage);
      socket.off("new-client-message", handleClientMessage);
    };
  }, [currentUUID, currentRoleId, addNotification, isConnected]);
};

export default useNotificationListener;
